/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementUnit } from './MeasurementUnit';
import {
    MeasurementUnitFromJSON,
    MeasurementUnitFromJSONTyped,
    MeasurementUnitToJSON,
    MeasurementUnitToJSONTyped,
} from './MeasurementUnit';
import type { WearDirection } from './WearDirection';
import {
    WearDirectionFromJSON,
    WearDirectionFromJSONTyped,
    WearDirectionToJSON,
    WearDirectionToJSONTyped,
} from './WearDirection';
import type { MeasuredDimension } from './MeasuredDimension';
import {
    MeasuredDimensionFromJSON,
    MeasuredDimensionFromJSONTyped,
    MeasuredDimensionToJSON,
    MeasuredDimensionToJSONTyped,
} from './MeasuredDimension';

/**
 * 
 * @export
 * @interface PartDimensionDto
 */
export interface PartDimensionDto {
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    partId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    dimensionTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    observableItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    baselineValue?: number;
    /**
     * 
     * @type {number}
     * @memberof PartDimensionDto
     */
    limit?: number;
    /**
     * 
     * @type {MeasurementUnit}
     * @memberof PartDimensionDto
     */
    measurementUnit?: MeasurementUnit;
    /**
     * 
     * @type {MeasuredDimension}
     * @memberof PartDimensionDto
     */
    measuredDimension?: MeasuredDimension;
    /**
     * 
     * @type {WearDirection}
     * @memberof PartDimensionDto
     */
    wearDirection?: WearDirection;
    /**
     * 
     * @type {string}
     * @memberof PartDimensionDto
     */
    externalId?: string;
}



/**
 * Check if a given object implements the PartDimensionDto interface.
 */
export function instanceOfPartDimensionDto(value: object): value is PartDimensionDto {
    return true;
}

export function PartDimensionDtoFromJSON(json: any): PartDimensionDto {
    return PartDimensionDtoFromJSONTyped(json, false);
}

export function PartDimensionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartDimensionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'partId': json['partId'] == null ? undefined : json['partId'],
        'dimensionTypeId': json['dimensionTypeId'] == null ? undefined : json['dimensionTypeId'],
        'observableItemId': json['observableItemId'] == null ? undefined : json['observableItemId'],
        'baselineValue': json['baselineValue'] == null ? undefined : json['baselineValue'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'measurementUnit': json['measurementUnit'] == null ? undefined : MeasurementUnitFromJSON(json['measurementUnit']),
        'measuredDimension': json['measuredDimension'] == null ? undefined : MeasuredDimensionFromJSON(json['measuredDimension']),
        'wearDirection': json['wearDirection'] == null ? undefined : WearDirectionFromJSON(json['wearDirection']),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function PartDimensionDtoToJSON(json: any): PartDimensionDto {
    return PartDimensionDtoToJSONTyped(json, false);
}

export function PartDimensionDtoToJSONTyped(value?: PartDimensionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partId': value['partId'],
        'dimensionTypeId': value['dimensionTypeId'],
        'observableItemId': value['observableItemId'],
        'baselineValue': value['baselineValue'],
        'limit': value['limit'],
        'measurementUnit': MeasurementUnitToJSON(value['measurementUnit']),
        'measuredDimension': MeasuredDimensionToJSON(value['measuredDimension']),
        'wearDirection': WearDirectionToJSON(value['wearDirection']),
        'externalId': value['externalId'],
    };
}

